import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { DeleteUser } from '../../../../services/api/user-api';
import { DeleteRoles } from '../../../../services/api/role-api';

import { DeleteProjectTemplate, DeleteProjectTemplateTask,
    DeleteProjectTemplateSubTask } from '../../../../services/api/project-template-api';

import { DeleteDepartment } from '../../../../services/api/department-api';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectUserID } from '../../../../redux/user/user-selector';

import { fetchUsers, fetchRoles, fetchTemplates,
    fetchTemplateTasks, fetchDepartments, setSelectedUser,
     setSelectedRoles, setSelectedDepartments,
    setSelectedTemplate, setSelectedTemplateTasks } from '../../../../redux/admin/admin-actions';

import { selectSearchQueryUsers,
    selectSearchRolesQuery, selectSearchTemplatesQuery, selectSearchTemplateTasksQuery,
    selectSearchDepartmentsQuery } from '../../../../redux/admin/admin-selector';

import './admin-actions-popup.styles.scss';
import { PulseLoader } from 'react-spinners';
import { deleteTaskTypes } from '../task-types/task-types-table/utils/task-types-table-util';

const AdminActionsPopup = (
   {
    showAdminActionsPopup,setShowAdminActionsPopup,
    type, selectedIDs, name, userID, fetchUsers, searchQueryUsers,
    searchQueryRoles,searchQueryDepartments,
    searchQueryTemplates, searchQueryTemplateTasks,
    fetchRoles,fetchDepartments, fetchTemplates, fetchTemplateTasks,
    setSelectedUsers,setSelectedRoles,
    setSelectedDepartments,setSelectedTemplates, setSelectedTemplateTasks,
    refreshTaskTypes, setSelectedTaskTypes
   }
) => {
    // const [popupMessage, setPopupMessage] = useState('');
    const [loading, setLoading] = useState(false); // used to disable buttons while api call is made.
    const [submitted, setSubmitted] = useState(false); // when user submits
    const [submitSuccess, setSubmitSuccess] = useState(false); //  checks if submit was successful
    const [title, setTitle] = useState('');
    const [results, setResults] = useState([]);

    useEffect(() => {
        console.log(results)
    //    results.length
    //     setSubmitted(true)
    }, [results])

    useEffect(() => {
        if(type.includes('user')) {
            if(selectedIDs.length === 1) { //if single user
                setTitle('Archive User')
            } else {
                setTitle('Archive Users')
            }
        }

        if(type.includes('role')) {
            if(selectedIDs.length === 1) { //if single user
                setTitle('Archive Role')
            } else {
                setTitle('Archive Roles')
            }
        }

        if(type.includes('template')) {
            if(selectedIDs.length === 1) { //if single user
                setTitle('Archive Template')
            } else {
                setTitle('Archive Templates')
            }
        }

        if(type.includes('department')) {
            if(selectedIDs.length === 1) { //if single user
                setTitle('Archive Department')
            } else {
                setTitle('Archive Departments')
            }
        }

        if(type.includes('task')) {
            if(selectedIDs.length === 1) { //if single user
                setTitle('Archive Template Task')
            } else {
                setTitle('Archive Template Tasks')
            }
        }

        if (type.includes('task type')) {
            if (selectedIDs.length === 1) {
                setTitle('Archive Task Type');
            } else {
                setTitle('Archive Task Types');
            }
        }
    }, [])

    const handleClose = () => {
        setShowAdminActionsPopup(false);
        (submitted && type.includes('user')) && fetchUsers(searchQueryUsers); // refresh table after submitting and closing
        (submitted && type.includes('role')) && fetchRoles(searchQueryRoles);
        (submitted && type.includes('department')) && fetchDepartments(searchQueryDepartments);
        (submitted && type.includes('template')) && fetchTemplates(searchQueryTemplates);
        (submitted && type.includes('task') && !type.includes('task type')) && fetchTemplateTasks(searchQueryTemplateTasks);
        (submitted && type.includes('task type') && refreshTaskTypes())

        submitted && clearSelectedRows();
    }

    const clearSelectedRows = () => {

        switch(type){
            case 'user':
                setSelectedUsers([]);
                break;
            case 'role':
                setSelectedRoles([]);
                break;
            case 'department':
                setSelectedDepartments([]);
                break;
            case 'template':
                setSelectedTemplates([]);
                break;
            case 'task':
                setSelectedTemplateTasks([]);
                break;
        }

    }

    const handleSubmit = async () => {
        try {
            let input = { userID: userID, deleteIDs: selectedIDs };
            let output = {};
            let archiveMessage;
            setLoading(true);
            setSubmitted(true);

            if (type.includes('user')) output = await DeleteUser(input);
            if (type.includes('role')) output = await DeleteRoles(input);
            if (type.includes('department')) output = await DeleteDepartment(input); //deprecate department
            if (type.includes('template')) {
                output = await DeleteProjectTemplate(input);
                archiveMessage = output.message[0];
            }
            if (type.includes('task') && !type.includes('task type')) output = await DeleteProjectTemplateTask(input);
            if (type.includes('subtask')) output = await DeleteProjectTemplateSubTask(input);
            if (type.includes('task type')) output = await deleteTaskTypes(selectedIDs);

            if (type.includes('template') && archiveMessage!="BadRequest") {
                if(archiveMessage == "allArchived") {
                    setTitle('Archive Confirmation');
                    setLoading(false);
                    setSubmitSuccess(true);
                } else if (archiveMessage == "someArchived" || archiveMessage == "noneArchived") {
                    setSubmitSuccess(false)
                    setLoading(false);
                }
            } else if (type.includes('template') && archiveMessage =="BadRequest") {
                setSubmitSuccess(false)
                setLoading(false);
            // if it failed or partially failed
            } else if (!output.ok && !type.includes('task type')) {
                output.json.then(value =>{
                    setResults(value.message) // getting the items that could not be archived
                });
                setSubmitSuccess(false)
                setLoading(false);
            } else if (output?.status === 200 && output?.ok) {
                setTitle('Archive Confirmation');
                setLoading(false);
                setSubmitSuccess(true);
            } else if (output?.length > 0 && type.includes('task type')) {
                if (((output[0].status === 200) || (output[0].status === 204)) && output[0].ok) {
                    setTitle('Archive Confirmation');
                    setLoading(false);
                    setSubmitSuccess(true);
                } else {
                    setSubmitSuccess(false);
                    setLoading(false);
                }
            } else {
                setTitle('Archive Confirmation');
                setLoading(false);
                setSubmitSuccess(true);
            }

        } catch (error) {
            setSubmitSuccess(false);
            setLoading(false);
            console.log(error);
        }
    }

    return (
        <Modal show={showAdminActionsPopup} onHide={() => handleClose()} dialogClassName='admin-actions-popup'>
            <Modal.Header>
                <Modal.Title className='modal-title-1'>{title}</Modal.Title>
                <Button className="close-document-viewer-btn btn-primary" onClick={() => handleClose()}></Button>
            </Modal.Header>
            <div className="select-member-divider-line"></div>
            {
                !loading ?
                    !submitted ?
                        <Modal.Body>
                            <div className='admin-popup-icon archive-popup-icon'></div>
                            <div className = 'admin-popup-message'>
                            {
                                selectedIDs.length === 1 ?
                                    <div>
                                        <div className = 'admin-popup-message'>{`Are you sure you want to archive the ${type}:`} </div>
                                        <div className='admin-popup-message bolded-name' style={{'fontWeight': 'bold'}}>{name} <span style={{'fontWeight': 'normal'}}> ?</span></div>
                                    </div>
                                :
                                    <React.Fragment>
                                        Are you sure you want to archive&nbsp;
                                        <span style={{'fontWeight': 'bold'}}> {`${selectedIDs.length} ${type}s`}</span>?
                                    </React.Fragment>
                            }
                            </div>

                            <div className='admin-popup-btn-container'>
                                <Button disabled = {loading} className="btn-wide table-buttons-container" onClick={async () => await handleSubmit()}>
                                    Yes
                                </Button>
                                <Button className="btn-wide btn-outlined" onClick={() => handleClose()}>
                                    No
                                </Button>
                            </div>
                        </Modal.Body>
                    : submitSuccess ?
                        <Modal.Body>
                            <div className='admin-popup-icon submitted-popup-icon'></div>
                            <div className='admin-popup-message'>
                                Archive successful. Contact support@triyo.io to unarchive
                            </div>

                            <div className='admin-popup-btn-container'>
                                <Button className="btn-wide table-buttons-container" onClick={() => handleClose()}>
                                    OK
                                </Button>
                            </div>
                        </Modal.Body>
                    : <Modal.Body>
                        <div className='admin-popup-icon failed-popup-icon'></div>
                        {
                            selectedIDs.length === 1 ?
                                <div>
                                    <div className='admin-popup-message'>{`Failed to archive ${type}:`} </div>
                                    <div className='admin-popup-message bolded-name' style={{'fontWeight': 'bold'}}>{name}</div>
                                    <div className='admin-popup-message-small'>{`as it is linked to active projects or tasks`} </div>
                                </div>
                            :
                                selectedIDs.length === results.length ?
                                    <React.Fragment>
                                        <div className='admin-popup-message'>Failed to archive&nbsp;
                                        <span style={{'fontWeight': 'bold'}}> {`${selectedIDs.length} ${type}s`}</span></div>
                                        <div className='admin-popup-message-small'>{`as they are linked to active projects or tasks`} </div>
                                    </React.Fragment>
                                :
                                    <div className='admin-popup-message'>{`Some ${type}s could not be archived as they are linked to active projects or tasks`}</div>
                        }
                        <div className='admin-popup-btn-container'>
                            <Button className="btn-wide table-buttons-container" onClick={() => handleClose()}>
                                OK
                            </Button>
                        </div>
                    </Modal.Body>

            :
                <div className='modal-loader'><PulseLoader/></div>
            }
        </Modal>
    )
}

const mapState = createStructuredSelector({
    userID: selectUserID,
    searchQueryUsers: selectSearchQueryUsers,
    searchQueryRoles: selectSearchRolesQuery,
    searchQueryDepartments: selectSearchDepartmentsQuery,
    searchQueryTemplates: selectSearchTemplatesQuery,
    searchQueryTemplateTasks: selectSearchTemplateTasksQuery
})

const mapDispatch = (dispatch) => ({
    fetchUsers: searchQuery => dispatch(fetchUsers(searchQuery)),
    fetchRoles: searchQuery => dispatch(fetchRoles(searchQuery)),
    fetchDepartments: searchQuery => dispatch(fetchDepartments(searchQuery)),
    fetchTemplates: searchQuery => dispatch(fetchTemplates(searchQuery)),
    fetchTemplateTasks: searchQuery => dispatch(fetchTemplateTasks(searchQuery)),
    setSelectedUsers: idList => dispatch(setSelectedUser(idList)),
    setSelectedRoles: idList => dispatch(setSelectedRoles(idList)),
    setSelectedDepartments: idList => dispatch(setSelectedDepartments(idList)),
    setSelectedTemplates: idList => dispatch(setSelectedTemplate(idList)),
    setSelectedTemplateTasks: idList => dispatch(setSelectedTemplateTasks(idList))
    // fetchAllUsers: () => dispatch(fetchAllUsers()),
})

export default connect(mapState, mapDispatch)(AdminActionsPopup);
